import { $axios, apiList } from '@/api'


export default {
    actions: {
        getProfiInfo(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.profi.getProfiInfo.method,
                    params: {
                        wsfunction: apiList.profi.getProfiInfo.moodle_method,
                        id: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getStatusAttempt(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.profi.getStatusAttempt.method,
                    params: {
                        wsfunction: apiList.profi.getStatusAttempt.moodle_method,
                        id: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getResults(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.profi.getResults.method,
                    params: {
                        wsfunction: apiList.profi.getResults.moodle_method,
                        id: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        startProfiAttempt(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.profi.startProfiAttempt.method,
                    params: {
                        wsfunction: apiList.profi.startProfiAttempt.moodle_method,
                        id: payload[0],
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        clearAttempt(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.profi.clearAttempt.method,
                    params: {
                        wsfunction: apiList.profi.clearAttempt.moodle_method,
                        id: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getQuestion(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.profi.getQuestion.method,
                    params: {
                        wsfunction: apiList.profi.getQuestion.moodle_method,
                        id: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        stopAttempt(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.profi.stopAttempt.method,
                    params: {
                        wsfunction: apiList.profi.stopAttempt.moodle_method,
                        id: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        skipCompetence(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.profi.skipCompetence.method,
                    params: {
                        wsfunction: apiList.profi.skipCompetence.moodle_method,
                        id: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        setAnswer(_, payload) {
            const answers = payload.answers.map(num => ({ id: num }));
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.profi.setAnswer.method,
                    params: {
                        wsfunction: apiList.profi.setAnswer.moodle_method,
                        id: payload.id,
                        questionid: payload.questionid,
                        answers: answers
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
    }
}
